import { useState, useCallback } from "react";
import { Button, CircularProgress, TextField, Typography } from "@mui/material";
import { Save } from "@mui/icons-material";

const ChangePasswordForm = () => {
    const backendEndpoint = process.env.REACT_APP_BACKEND_ENDPOINT;

    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [newPasswordRepeat, setNewPasswordRepeat] = useState("");

    const [isLoading, setIsLoading] = useState(false);
    const [validate, setValidate] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const cleanValidations = () => {
        setValidate(false);
        setErrorMessage("");
    };

    const getCookieValue = useCallback(
        (name) =>
            document.cookie
                .match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")
                ?.pop() || "",
        [],
    );

    const handleResetPassword = () => {
        setValidate(true);

        if (
            !currentPassword ||
            !newPassword ||
            !newPasswordRepeat ||
            newPassword !== newPasswordRepeat
        ) {
            return;
        }

        setIsLoading(true);

        fetch(`${backendEndpoint}/user/change_password/`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": getCookieValue("csrfToken"),
            },
            body: JSON.stringify({
                currentPassword,
                newPassword,
            }),
        })
            .then(async (response) => {
                if (response.ok) {
                    const result = await response.json();
                    return result;
                } else {
                    const result = await response.json();
                    throw new Error(result.detail);
                }
            })
            .then(() => {
                setCurrentPassword("");
                setNewPassword("");
                setNewPasswordRepeat("");

                setValidate(false);
                setIsLoading(false);
            })
            .catch((error) => {
                setErrorMessage(`${error}`.replace("Error: ", ""));

                setValidate(false);
                setIsLoading(false);
            });
    };

    return (
        <>
            <TextField
                value={currentPassword}
                onChange={(e) => {
                    setCurrentPassword(e.target.value);
                    cleanValidations();
                }}
                label="Sua senha atual*"
                type="password"
                variant="outlined"
                fullWidth
                margin="normal"
                error={validate && currentPassword === "" ? true : false}
                helperText={
                    validate && currentPassword === ""
                        ? "Preencha sua senha atual"
                        : ""
                }
            />

            <TextField
                value={newPassword}
                onChange={(e) => {
                    setNewPassword(e.target.value);
                    cleanValidations();
                }}
                label="Sua nova senha*"
                type="password"
                variant="outlined"
                fullWidth
                margin="normal"
                error={validate && newPassword === "" ? true : false}
                helperText={
                    validate && newPassword === ""
                        ? "Preencha sua nova senha"
                        : ""
                }
            />

            <TextField
                value={newPasswordRepeat}
                onChange={(e) => {
                    setNewPasswordRepeat(e.target.value);
                    cleanValidations();
                }}
                label="Repita sua nova senha*"
                type="password"
                variant="outlined"
                fullWidth
                margin="normal"
                error={
                    validate &&
                    (newPasswordRepeat === "" ||
                        newPasswordRepeat !== newPassword)
                        ? true
                        : false
                }
                helperText={
                    validate &&
                    (newPasswordRepeat === "" ||
                        newPasswordRepeat !== newPassword)
                        ? "Repita sua nova senha corretamente"
                        : ""
                }
            />

            {errorMessage ? (
                <Typography variant="h6">{errorMessage}</Typography>
            ) : null}

            <Button
                variant="contained"
                color="primary"
                sx={{
                    marginBottom: 2,
                    marginTop: 2,
                    borderRadius: "25px",
                    padding: "8px 40px 6px",
                    textTransform: "none",
                    float: "right",
                }}
                disabled={isLoading}
                startIcon={
                    isLoading ? (
                        <CircularProgress size="16px" color="inherit" />
                    ) : (
                        <Save />
                    )
                }
                onClick={handleResetPassword}
            >
                Salvar
            </Button>
        </>
    );
};

export default ChangePasswordForm;
